import React from 'react';
import { useState, useContext, useEffect } from "react";
import { ThemeContext } from '../../App.js';
import "../style.css";

import Chart from "react-apexcharts";
import ApexCharts from 'apexcharts';

export default function Stage(props) {
  const theme = useContext(ThemeContext);
  const reportsFeet = props.reading.unit == 'ft'
  const UNIT_CONVERSION_FACTOR = reportsFeet ? 1 : 304.8

  var options = {
    chart: {
      id: "stageChart", 
      redrawOnWindowResize: true, 
      animations:{enabled:true},
      toolbar:{
        show:true,
        tools:{
          download:false
        },
        export:{
          csv:{
            filename:"stageReadings",
            headerCategory: 'Date',
            headerValue: 'stage',
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString()
            }
          }
        }
      }
    },
    title: {
      text:"Water Level", 
      align: 'center',
      style:{fontSize:'21px'}
    },
    markers: {
      hover: {size: 10}
    },
    dataLabels: {
      enabled:false
    },
    colors:['#0080FF'],
    tooltip: {x:{format:"MM-dd HH:mm:ss"}},
    xaxis: {type: 'datetime',labels: {format: 'MM-dd HH:mm',datetimeUTC:false}},
    yaxis: {
        labels: {
            formatter: function (value) {
              return value.toFixed(1) + " ft.";
            }
        },
        max:(props.reading.max + props.reading.MLLW) / UNIT_CONVERSION_FACTOR,
        min:(props.reading.min + props.reading.MLLW) / UNIT_CONVERSION_FACTOR
    },
    zoom:{enabled:true,type:"xy",autoScaleYaxis:true},
    stroke:{
        width:2
    },
    annotations:{
      yaxis:[]
    }
  }

  var series = [{name:'stage',data:[]}];

  {console.log("StageGraph:site:",props.site)}
  {console.log("StageGraph:reading:",props.reading)}
  {console.log("StageGraph:messages:",props.messages)}

  // Add Thresholds
  props.reading.thresholds.forEach(threshold => {
    // console.log("StageGraph:Threshold:",threshold);
    var obj = {
            y:(threshold.value + props.reading.MLLW) / UNIT_CONVERSION_FACTOR,
            borderColor:threshold.color,
            fillColor:threshold.color,
            strokeDashArray:0,
            label: {
                borderColor:threshold.color,
                style: {
                    color: '#FFFFFF',
                    background:threshold.color
                },
                text: threshold.name + " (" + ((threshold.value + props.reading.MLLW) / UNIT_CONVERSION_FACTOR).toFixed(1) + " ft.)",
                textAnchor:'start',
                position:'left',
                offsetX:10
            },
    }
    options.annotations.yaxis.push(obj);
  })

  // Add data points
  props.messages.forEach(message => {
    var dt = message.msg.timestamp * 1000;
    var dist;

    if(message.msg.senix != null) {
      dist = ((props.reading.elevation - message.msg.senix.mm + props.reading.MLLW) / UNIT_CONVERSION_FACTOR).toFixed(2);
      series[0].data.push({x:dt,y:dist});
    }

    if(message.msg.maxbotix != null) {
      dist = ((props.reading.elevation - message.msg.maxbotix.mm + props.reading.MLLW) / UNIT_CONVERSION_FACTOR).toFixed(2);
      series[0].data.push({x:dt,y:dist});
    }

    if(message.msg.csi != null) {
      dist = (props.reading.elevation - message.msg.csi.basic.ft + props.reading.MLLW).toFixed(2);
      series[0].data.push({x:dt,y:dist});
    }

    if(message.msg.vega != null) {
      dist = ((props.reading.elevation - message.msg.vega.distance + props.reading.MLLW) / UNIT_CONVERSION_FACTOR).toFixed(2);
      series[0].data.push({x:dt,y:dist});
    }
  })

  return (
    <Chart 
      className="chart"
      type="area"
      width="100%"
      height="300px"
      options={options}
      series={series}
    >
    </Chart>
  )
}

